export const FETCH_PROVIDERS = 'provider/FETCH_PROVIDERS'
export const FETCH_PROVIDERS_SUCCESS = 'provider/FETCH_PROVIDERS_SUCCESS'
export const FETCH_PROVIDERS_FAILURE = 'provider/FETCH_PROVIDERS_FAILURE'
export const RESET_PROVIDERS = 'provider/RESET_PROVIDERS'

export const FETCH_PROVIDER = 'provider/FETCH_PROVIDER'
export const FETCH_PROVIDER_SUCCESS = 'provider/FETCH_PROVIDER_SUCCESS'
export const FETCH_PROVIDER_FAILURE = 'provider/FETCH_PROVIDER_FAILURE'
export const RESET_PROVIDER = 'provider/RESET_PROVIDER'

export const CREATE_PROVIDER = 'provider/CREATE_PROVIDER'
export const CREATE_PROVIDER_SUCCESS = 'provider/CREATE_PROVIDER_SUCCESS'
export const CREATE_PROVIDER_FAILURE = 'provider/CREATE_PROVIDER_FAILURE'
export const RESET_CREATE_PROVIDER = 'provider/RESET_CREATE_PROVIDER'

export const UPDATE_PROVIDER = 'provider/UPDATE_PROVIDER'
export const UPDATE_PROVIDER_SUCCESS = 'provider/UPDATE_PROVIDER_SUCCESS'
export const UPDATE_PROVIDER_FAILURE = 'provider/UPDATE_PROVIDER_FAILURE'
export const RESET_UPDATE_PROVIDER = 'provider/RESET_UPDATE_PROVIDER'

export const DELETE_PROVIDER = 'provider/DELETE_PROVIDER'
export const DELETE_PROVIDER_SUCCESS = 'provider/DELETE_PROVIDER_SUCCESS'
export const DELETE_PROVIDER_FAILURE = 'provider/DELETE_PROVIDER_FAILURE'
export const RESET_DELETE_PROVIDER = 'provider/RESET_DELETE_PROVIDER'


// WEBPACK FOOTER //
// ./src/store/provider/actionTypes.js